import { render } from "./LMSPage.vue?vue&type=template&id=5026b351&ts=true"
import script from "./LMSPage.vue?vue&type=script&lang=ts"
export * from "./LMSPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__